import { Role } from '@/domain/Role'
import axios from 'axios'

/**
 * 権限サービス
 */
export default class RolesService {
    /** インスタンス */
    private static _instance: RolesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new RolesService();
        }
        return this._instance;
    }
    
    /**
     * 権限一覧を検索
     */
    public async findAll(): Promise<Role[]> {
        return await axios.get("/api/roles")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Role[]).map(x => new Role({ ...x }))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
